export default __webpack_public_path__ + "static/media/burgerDark.7db90c4b.svg";